import Core from "../../templates/Core";
import { ButtonAnchor, ButtonPrimary, ButtonSecondary } from "../../components/buttons/Buttons";
import { ArticleHeader, PageHeader, PageSubHeader } from "../../components/typography/Headers";
import { Ellipsis } from "../../components/utilities/Helpers";
import { Input, Label, Search, Select } from "../../components/forms/formFields";
import { pageSubHeader, paragraph3 } from "../../utilities/typography";
import { useEffect, useRef, useState } from "react";
import { LinkPrimary } from "../../components/links/Links";
import { Avatar, IconMediaObject } from "../../components/containers/ImageContainer";
import { placeholder, rem } from "../../utilities/helpers";
import { ContactCard } from "../../components/containers/Cards";
import Calendar, { TimeCalendar } from "../../components/containers/Calendars";
import { useAppContext } from "../../Context";

export const SupervisorCalendarForm = props => {
	const [values, setValues] = useState<any>({
		"date": "",
		"start_time": "",
		"end_time": "",
		"provider": "",
		"region": ""
	});

	const date = useRef();
	const start_time = useRef();
	const end_time = useRef();
	const provider = useRef();
	const region = useRef();

	useEffect(() => {
		console.log(values);
	}, [values])

	return (<>
			<div className="tw-px-xl tw-py-xl">
				<div className="tw-flex tw-items-center tw-flex tw-border-b tw-border-light tw-pb">
					<div className="tw-flex-grow tw-flex-shrink-0">
						<PageHeader>
							<Ellipsis>
								Supervisor Calendar
							</Ellipsis>
						</PageHeader>
					</div>
					<div className="tw-flex tw-items-center tw-justify-end tw-flex-grow tw-flex-shrink-0">
						<ul className="tw-list-none tw-flex tw-space-x-md">
							<li>
								<ButtonPrimary iconNotRounded svg={`<svg width="${rem('24')}" height="${rem('24')}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM12 7C13.66 7 15 8.34 15 10C15 11.66 13.66 13 12 13C10.34 13 9 11.66 9 10C9 8.34 10.34 7 12 7ZM18 19H6V17.6C6 15.6 10 14.5 12 14.5C14 14.5 18 15.6 18 17.6V19Z" fill="currentColor"/></svg>`}>
									Assign Service Supervisor
								</ButtonPrimary>
							</li>
							<li>
								<ButtonSecondary iconNotRounded svg={`<svg width="${rem('24')}" height="${rem('24')}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.1102 6.1665C13.0855 6.16877 14.02 6.55749 14.7092 7.24749C15.3984 7.93749 15.7861 8.87253 15.7872 9.84777C15.7866 10.0958 15.7621 10.3432 15.7142 10.5866C15.6974 10.6509 15.6939 10.7179 15.7038 10.7836C15.7138 10.8493 15.737 10.9123 15.7721 10.9687C15.8072 11.0251 15.8534 11.0738 15.9079 11.1118C15.9623 11.1498 16.024 11.1764 16.0891 11.1898C16.1541 11.2032 16.2213 11.2032 16.2863 11.1899C16.3514 11.1766 16.4131 11.1501 16.4677 11.1122C16.5222 11.0742 16.5684 11.0256 16.6036 10.9692C16.6387 10.9128 16.662 10.8499 16.6721 10.7842C16.7358 10.4761 16.7675 10.1623 16.7666 9.84777C16.7699 9.04868 16.5677 8.26217 16.1794 7.56377C15.7911 6.86536 15.2297 6.27852 14.5492 5.85961C13.8688 5.4407 13.092 5.20379 12.2935 5.17162C11.4951 5.13946 10.7018 5.31313 9.98983 5.67595C9.27785 6.03877 8.67113 6.57856 8.22791 7.24347C7.7847 7.90838 7.51988 8.67608 7.4589 9.47284C7.39792 10.2696 7.54283 11.0687 7.8797 11.7933C8.21657 12.5179 8.73409 13.1437 9.38256 13.6106C9.46552 13.6729 9.56666 13.7061 9.67036 13.7051C9.77352 13.7049 9.87394 13.672 9.95732 13.6113C10.0407 13.5505 10.1028 13.465 10.1347 13.3669C10.1666 13.2688 10.1667 13.1632 10.135 13.065C10.1033 12.9668 10.0414 12.8812 9.95816 12.8203C9.33126 12.3623 8.86521 11.7178 8.62663 10.979C8.38806 10.2402 8.38917 9.44486 8.62982 8.70672C8.87046 7.96858 9.33831 7.32542 9.96649 6.86919C10.5947 6.41295 11.351 6.167 12.1274 6.1665H12.1102Z" fill="curentColor"/><path d="M5.57646 12.3995C5.99382 12.3983 6.39369 12.2317 6.6884 11.9362C6.98312 11.6407 7.14862 11.2404 7.14861 10.823V9.65463C7.14963 9.38053 7.07879 9.11095 6.94312 8.87278C6.80745 8.63461 6.61171 8.43617 6.37543 8.29724C6.37677 6.92269 6.86705 5.59345 7.75859 4.54725C8.73797 3.50773 10.1984 2.97938 12.1057 2.97938C14.0129 2.97938 15.4734 3.50773 16.4484 4.54725C17.3461 5.59829 17.8369 6.93652 17.8316 8.31872C17.6094 8.46314 17.4271 8.66126 17.3018 8.89476C17.1764 9.12826 17.1119 9.3896 17.1142 9.65463V10.8316C17.1141 11.2156 17.2564 11.586 17.5137 11.8711L15.366 13.3445C15.2647 13.2255 15.139 13.1298 14.9974 13.0639C14.8558 12.9979 14.7017 12.9632 14.5455 12.9622H13.3342C13.1917 12.9622 13.0506 12.9903 12.9189 13.045C12.7873 13.0997 12.6678 13.1798 12.5672 13.2807C12.4667 13.3817 12.387 13.5016 12.3329 13.6334C12.2787 13.7652 12.2511 13.9064 12.2517 14.0489C12.2517 14.336 12.3658 14.6114 12.5688 14.8144C12.7718 15.0174 13.0471 15.1314 13.3342 15.1314H14.5369C14.7611 15.1252 14.9777 15.0496 15.157 14.9149C15.3363 14.7802 15.4694 14.5932 15.5378 14.3797L18.4802 12.3694C18.5446 12.3736 18.6092 12.3736 18.6735 12.3694C19.0913 12.3683 19.4916 12.2018 19.787 11.9064C20.0824 11.611 20.2488 11.2107 20.25 10.7929V9.65463C20.2508 9.26386 20.1061 8.88679 19.844 8.59693C19.5819 8.30707 19.2213 8.12519 18.8325 8.08676C18.7928 6.53856 18.214 5.05276 17.1959 3.88574C16.0232 2.63144 14.3179 2 12.1271 2C9.93642 2 8.2268 2.63144 7.05841 3.88574C6.0375 5.0531 5.45702 6.54076 5.41752 8.09105C5.02939 8.12942 4.66938 8.31068 4.40741 8.59964C4.14545 8.88859 4.00024 9.2646 4 9.65463V10.8316C4.00339 11.2479 4.17084 11.646 4.466 11.9395C4.76115 12.2331 5.16019 12.3983 5.57646 12.3995ZM14.5369 14.1434H13.3342C13.3068 14.1434 13.2806 14.1326 13.2613 14.1133C13.242 14.0939 13.2311 14.0677 13.2311 14.0404C13.2311 14.013 13.242 13.9868 13.2613 13.9675C13.2806 13.9481 13.3068 13.9373 13.3342 13.9373H14.5369C14.5643 13.9373 14.5905 13.9481 14.6098 13.9675C14.6292 13.9868 14.64 14.013 14.64 14.0404C14.64 14.0677 14.6292 14.0939 14.6098 14.1133C14.5905 14.1326 14.5643 14.1434 14.5369 14.1434ZM19.262 9.65463V10.8316C19.262 10.9094 19.2467 10.9865 19.2169 11.0584C19.1871 11.1304 19.1434 11.1957 19.0884 11.2508C19.0333 11.3058 18.968 11.3495 18.8961 11.3793C18.8241 11.409 18.7471 11.4244 18.6692 11.4244C18.5914 11.4244 18.5143 11.409 18.4424 11.3793C18.3705 11.3495 18.3051 11.3058 18.2501 11.2508C18.195 11.1957 18.1513 11.1304 18.1216 11.0584C18.0918 10.9865 18.0764 10.9094 18.0764 10.8316V9.65463C18.0764 9.49741 18.1389 9.34663 18.2501 9.23547C18.3612 9.1243 18.512 9.06184 18.6692 9.06184C18.8264 9.06184 18.9772 9.1243 19.0884 9.23547C19.1995 9.34663 19.262 9.49741 19.262 9.65463ZM4.97938 9.65463C4.97938 9.49741 5.04184 9.34663 5.15301 9.23547C5.26418 9.1243 5.41495 9.06184 5.57216 9.06184C5.72938 9.06184 5.88015 9.1243 5.99132 9.23547C6.10249 9.34663 6.16495 9.49741 6.16495 9.65463V10.8316C6.16495 10.9888 6.10249 11.1396 5.99132 11.2508C5.88015 11.3619 5.72938 11.4244 5.57216 11.4244C5.41495 11.4244 5.26418 11.3619 5.15301 11.2508C5.04184 11.1396 4.97938 10.9888 4.97938 10.8316V9.65463Z" fill="currentColor"/><path d="M12.2512 15.4408C7.8225 15.4408 4.23145 17.6186 4.23145 22.0001H20.2709C20.2709 17.6186 16.6842 15.4408 12.2512 15.4408Z" fill="currentColor"/></svg>`}>
									Service Supervisor List
								</ButtonSecondary>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="tw-px-xl tw-pb-xl tw-text-dark">

				<div>
					{/* <!-- Start Content --> */}
					<div>

						<form className="tw-p-0 tw-m-0 tw-border-0">
							<PageSubHeader className="tw-py-xl" tag="legend">
								Assign Backup Supervisor
							</PageSubHeader>
							<div className="tw-space-y">

								<div className="-tw-m">
									<div className="tw-flex">
										<div className="tw-flex-shrink-0 tw-flex tw-items-center tw-p tw-min-w-200px">
											<Label for="date" className="tw-flex-grow" childClasses={ pageSubHeader }>
												Date
											</Label>
										</div>
										<div className="tw-flex-grow tw-flex tw-items-start tw-p">
											<Input id="date" type="date" onChange={ e => setValues({...values, "date": e.target.value }) } ref={ date } value={ values.date } alt className="tw-flex-grow tw-max-w300px" />
										</div>
									</div>
								</div>

								<div className="-tw-m">
									<div className="tw-flex">
										<div className="tw-flex-shrink-0 tw-flex tw-items-center tw-p tw-min-w-200px">
											<Label for="start_time" className="tw-flex-grow" childClasses={ pageSubHeader }>
												Start Time
											</Label>
										</div>
										<div className="tw-flex-grow tw-flex tw-items-start tw-p">
											<Input id="start_time" type="time" onChange={ e => setValues({...values, "start_time": e.target.value }) } ref={ start_time } value={ values.start_time } alt className="tw-flex-grow tw-max-w300px" />
										</div>
									</div>
								</div>

								<div className="-tw-m">
									<div className="tw-flex">
										<div className="tw-flex-shrink-0 tw-flex tw-items-center tw-p tw-min-w-200px">
											<Label for="end_time" className="tw-flex-grow" childClasses={ pageSubHeader }>
												End Time
											</Label>
										</div>
										<div className="tw-flex-grow tw-flex tw-items-start tw-p">
											<Input id="end_time" type="time" onChange={ e => setValues({...values, "end_time": e.target.value }) } ref={ end_time } value={ values.end_time } alt className="tw-flex-grow tw-max-w300px" />
										</div>
									</div>
								</div>

								<div className="-tw-m">
									<div className="tw-flex">
										<div className="tw-flex-shrink-0 tw-flex tw-items-center tw-p tw-min-w-200px">
											<Label for="provider" className="tw-flex-grow" childClasses={ pageSubHeader }>
												Provider
											</Label>
										</div>
										<div className="tw-flex-grow tw-flex tw-items-start tw-p">
											<Input id="provider" onChange={ e => setValues({...values, "provider": e.target.value }) } ref={ provider } value={ values.provider } alt className="tw-flex-grow tw-max-w-500px" />
										</div>
									</div>
								</div>

								<div className="-tw-m">
									<div className="tw-flex">
										<div className="tw-flex-shrink-0 tw-flex tw-items-center tw-p tw-min-w-200px">
											<Label for="region" className="tw-flex-grow" childClasses={ pageSubHeader }>
												Region
											</Label>
										</div>
										<div className="tw-flex-grow tw-flex tw-items-start tw-p">
											<Select id="region" onChange={ e => setValues({...values, "region": e.target.value }) } ref={ region } value={ values.region } alt className="tw-flex-grow tw-max-w-500px">
												<option value="">--Select--</option>
												<option value="Franklin">Franklin</option>
											</Select>
										</div>
									</div>
								</div>

							</div>
							<div className="tw-pt-xxl tw-pb-xl">
								<ul className="tw-list-none tw-flex tw-justify-end tw-space-x-lg">
									<li>
										<ButtonSecondary large className="tw-px tw-min-w-200px" onClick={ e => {
											e.preventDefault();
										}}>
											Discard
										</ButtonSecondary>
									</li>
									<li>
										<ButtonPrimary large className="tw-px tw-min-w-200px" onClick={ e => {
											alert("Submit")
											e.preventDefault();
										}}>
											Assign
										</ButtonPrimary>
									</li>
								</ul>
							</div>
						</form>

					</div>
					{/* <!-- End Content --> */}
				</div>
			</div>
	</>);
};


const SupervisorCalendar = props => {

	const appContext = useAppContext();

	useLayoutEffect(() => {
		appContext.setFullScreen(false);
	}, []);

	return (<>
			<div className="tw-px-xl tw-py-xl">
				<div className="tw-flex tw-items-center tw-flex tw-px-xl tw-py-xl tw-text-dark">
					<div className="tw-flex-grow tw-flex-shrink-0">
						<PageHeader>
							<Ellipsis>
								Supervisor Calendar
							</Ellipsis>
						</PageHeader>
					</div>
					<div className="tw-flex tw-items-center tw-justify-end tw-flex-grow tw-flex-shrink-0">
						<Search />
					</div>
				</div>
				<div className="tw-px-xl">
					<ButtonAnchor iconNotRounded svg={`<svg width="${rem('12')}" height="${rem('18')}" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.115 15.885L4.245 9L11.115 2.115L9 0L0 9L9 18L11.115 15.885Z" fill="currentColor"/></svg>`}>
						Back to Client List
					</ButtonAnchor>
				</div>
			</div>
			<div className="tw-px-xl tw-pb-xl tw-text-dark">

				<div className="tw-px-xl">
					{/* <!-- Start Content --> */}
					<div>
						<ContactCard />
						<TimeCalendar />
					</div>
					{/* <!-- End Content --> */}
				</div>
			</div>
	</>);
};

export default SupervisorCalendar;

function useLayoutEffect(arg0: () => void, arg1: undefined[]) {
	throw new Error("Function not implemented.");
}
